@import 'styles/blaze/mixins';

.newHeader {
  padding-left: 0px;
}

.header {
  margin-bottom: 10px;
}

.details {
  align-items: center;
  border-radius: 10px;
  box-shadow: 1px 1px 0 0 rgba(255, 255, 255, 0.9) inset, 0 2px 12px 0 rgba(0, 0, 0, 0.04);
  backdrop-filter: blur(35px);
  display: flex;
  justify-content: space-between;
  padding: 20px 30px 20px 20px;

  &.virtual_marketer {
    background: linear-gradient(
        270deg,
        var(--Magenta-50, rgba(182, 75, 248, 0.2)) 0%,
        var(--Blue-70, rgba(1, 121, 207, 0.2)) 100%
      ),
      var(--background, #f3f5f6);

    &.autopilotPriceEnabled {
      background: var(--Pioneer-Plan, linear-gradient(266deg, #7fe26d 2.66%, #36b234 101.2%));
    }
  }

  &.blaze_autopilot_starter {
    background: var(--Starter-Plan, linear-gradient(268deg, #ffc934 1.28%, #f9ad11 30.11%, #ee8330 99.59%));
  }

  &.blaze_autopilot_growth {
    background: var(--Growth-Plan, linear-gradient(268deg, #65cefe 1.28%, #0c7dff 99.59%));
  }

  &.blaze_autopilot_enterprise {
    background: var(--Enterprise-Plan, linear-gradient(266deg, #bf3ffb 2.66%, #6226ee 101.2%));
  }

  &.free {
    background: var(--Free-Plan, linear-gradient(267deg, #aaa 4.41%, #7c7c7c 99.02%));
  }
}

.planDetails {
  display: flex;
  flex-direction: column;
  gap: 5px;

  .message {
    align-items: center;
    display: flex;
    gap: 10px;
  }

  .nextPaymentPill {
    align-items: center;
    background: var(--light-20);
    border-radius: 16px;
    display: flex;
    padding: 6px 12px;
    gap: 3px;
  }
}

.managePlanButtonContainer {
  background: var(--light-100);
  border-radius: 6px;
}

.horizontalRuler {
  background: var(--dark-4, rgba(0, 0, 0, 0.04));
  height: 1px;
  margin: 31px 0;
}

.questionCopy {
  color: var(--dark-60, rgba(0, 0, 0, 0.6));
  @include sm-sohne;
  margin-top: 5px;
}
